import { useCallback, useEffect, useRef, useState } from "react";
import { accountService } from "../_services/accounts.service";

const IDLE_MS = 15 * 60 * 1000; //15 minutes
const IDLE_DIALOG_MS = 1 * 60 * 1000; //1 min
const CHECK_MS = 1000;
const STORAGE_KEY = 'idle_lastActivity';



export function useIdleLogout() {
    const [isIdleDialogOpen, setIdleDialogOpen] = useState(false);
    const [secondsLeft, setSecondsLeft] = useState(IDLE_DIALOG_MS / 1000);

    const lastActivity = useRef(Date.now());
    const idleDialogShown = useRef(false);
    const loggingOut = useRef(false);

    const touch = useCallback(() => {
        if (idleDialogShown.current) return;

        const now = Date.now();

        lastActivity.current = now;

        try {
            localStorage.setItem(STORAGE_KEY, String(now));
        } catch (e) {
            console.warn('idle localStorage failed', e);
        }

    }, [])

    const stayLoggedIn = useCallback(() => {
        idleDialogShown.current = false;
        setIdleDialogOpen(false);

        const now = Date.now();

        lastActivity.current = now;

        try {
            localStorage.setItem(STORAGE_KEY, String(now));
        } catch (e) {
            console.warn('idle localStorage failed', e);
        }

    }, [])

    const doLogOut = useCallback(() => {
        if (loggingOut.current) return;
        loggingOut.current = true;
        accountService.logout();
    }, [])


    useEffect(() => {
        const events = ['click', 'keydown', 'mousemove', 'scroll', 'touchstart'] as const;

        events.forEach((e) => {
            document.addEventListener(e, touch, { passive: true });
        })

        const onStorage = (e: StorageEvent) => {
            if (e.key === STORAGE_KEY && e.newValue) {
                lastActivity.current = Number(e.newValue);
                if (idleDialogShown.current) {
                    idleDialogShown.current = false;
                    setIdleDialogOpen(false);
                }
            }
        }
        window.addEventListener('storage', onStorage);

        const id = window.setInterval(() => {
            const idleFor = Date.now() - lastActivity.current;

            if (!idleDialogShown.current && idleFor >= IDLE_MS) {
                idleDialogShown.current = true;
                setIdleDialogOpen(true);
                setSecondsLeft(Math.ceil(IDLE_DIALOG_MS / 1000));
            }

            if (idleDialogShown.current) {
                const left = Math.ceil((IDLE_MS + IDLE_DIALOG_MS - idleFor) / 1000)
                setSecondsLeft(Math.max(0, left));
                if (idleFor >= IDLE_MS + IDLE_DIALOG_MS) {
                    doLogOut();
                }
            }
        }, CHECK_MS)

        return () => {
            events.forEach((e) => document.removeEventListener(e, touch));
            window.removeEventListener('storage', onStorage);
            clearInterval(id);
        }
    }, [touch, doLogOut])

    return{
        isIdleDialogOpen,
        secondsLeft,
        stayLoggedIn,
        logoutNow: doLogOut,
    };
}